import React, { Component, Fragment } from 'react';
import axios from 'axios';
import Recruitment from '../../admin/Recruitment';
import RecruitmentPanel from '../../admin/RecruitmentPanel';
import Cookie from 'universal-cookie';
import AdminNavbar from '../../admin/AdminNavbar';
import { Count, Column, Container, Log } from '../../admin/Styles';
import { environment } from '../../../utils';
import { errorStatusCodes } from '../../admin/AdminNavbar';

const cookie = new Cookie();

const BACKEND_URL = environment.REACT_APP_BACKEND_HTTP_URL;

class AdminRecruitmentPage extends Component {
  state = {
    recruitments: [],
    selected: null,
    loading: true,
    logScrolled: false
  };
  logRef = React.createRef();

  fetchRecruitment = async () => {
    const { history } = this.props;
    const token = cookie.get('jwt');

    try {
      const resp = await axios.get(`${BACKEND_URL}/admin/recruitment`, {
        headers: {
          Authorization: token
        }
      });
      const recruitment = resp.data;
      this.setState({
        recruitments: recruitment,
        loading: false
      });
    } catch (err) {
      console.error(err);
      if (err.response && errorStatusCodes.includes(err.response.status)) {
        cookie.remove('jwt');
        history.push('/login?next=/admin/recruitment');
        return;
      }

      this.setState({
        loading: false,
        error: 'Error, check console'
      });
    }
  };

  componentDidMount() {
    this.refresh();
  }

  componentDidUpdate = () => {
    const { logScrolled } = this.state;
    // Scroll to bottom of chat log
    if (this.logRef.current && !logScrolled) {
      this.logRef.current.scrollTop = this.logRef.current.scrollHeight;
      this.setState({
        logScrolled: true
      });
    }
  };

  onSelect = (data, type) => {
    console.log(data);
    this.setState({
      selected: data
    });
  };

  isSelected = (msg, other) => {
    return msg && other && msg._id === other._id;
  };

  refresh = () => {
    this.fetchRecruitment();
  };

  renderContent = () => {
    const { recruitments, selected, loading } = this.state;
    const { history } = this.props;

    if (loading) {
      return <h2>Loading...</h2>;
    }

    let recruitmentRows, count;
    if (recruitments.length === 0) {
      recruitmentRows = <div>No applications.</div>;
    } else {
      recruitmentRows = recruitments.map((m, index) => (
        <Recruitment
          selected={this.isSelected(m, selected)}
          onSelect={this.onSelect}
          key={index}
          data={m}
        />
      ));
      count = recruitmentRows.length;
    }

    return (
      <Fragment>
        {count && <Count>Total: {count} application(s)</Count>}
        <Column>
          <Log ref={this.logRef}>{recruitmentRows}</Log>
        </Column>
        <Column hidden={!selected}>
          <RecruitmentPanel
            refresh={this.refresh}
            history={history}
            data={selected}
          />
        </Column>
      </Fragment>
    );
  };

  render() {
    return (
      <Container>
        <AdminNavbar />
        <h2>Recruitment</h2>
        {this.renderContent()}
      </Container>
    );
  }
}

export default AdminRecruitmentPage;
